import React, { useState } from "react";
import Loader from './Loader';
import { api } from '../services/api';
import PainDiaryPackages from "./PainDiaryPackages";
import PainDiaryAttributes from "./PainDiaryAttributes";
import PainDiaryPrivacy from "./PainDiaryPrivacy";
import { useNavigate } from 'react-router-dom';
function DiaryUpsell({
    toast,
    loadData,
    diary,
    setDiary,
    setIsEditing,
    steps,
    setSteps
}) {
    const [currentStep, setCurrentStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const close = () => {
        if (diary.id) {
            return setIsEditing(false)
        }
        navigate("/")
    }

    const back = () => {
        const newStep = currentStep - 1;
        
        if (steps[newStep - 1] === "packages") {
            setSteps(["packages", "privacy"])
        }
        
        setCurrentStep(newStep);
    }

    const onContinue = (newDiary) => {
        if (newDiary) {
            setDiary(newDiary)
        }
        if (newDiary?.custom) {
            setSteps(["packages", "custom package", "privacy"])
        }
        if (currentStep === steps.length) {
            api.saveDiary({
                ...diary
            })
            .then(res => {
                if (diary.id) {
                    toast("Pain Diary Updated!")
                } else {
                    toast("Pain Diary Created!")
                }
                setIsEditing(false)
                loadData()
            })
            .catch(err => {
                console.log("could not save diary: ", err)
            })
        } else {
            setCurrentStep(prev => prev + 1)
        }
    }


    if (isLoading) {
        return (
            <Loader size="large" />
        );
    }


    return (
        <div className="form-container">
            {(steps[currentStep - 1] === "packages") && (
                // TODO: FIX PACKAGE ON CLICK
                <PainDiaryPackages
                    currentStep={currentStep}
                    totalSteps={steps.length}
                    diary={diary}
                    setDiary={setDiary}
                    onContinue={onContinue}
                    close={close}
                />
            )}
            {(steps[currentStep - 1] === "custom package") && (
                <PainDiaryAttributes
                    currentStep={currentStep}
                    totalSteps={steps.length}
                    diary={diary}
                    setDiary={setDiary}
                    onContinue={onContinue}
                    close={close}
                    back={back}
                />
            )}
            {(steps[currentStep - 1] === "privacy" && (
                <PainDiaryPrivacy
                    currentStep={currentStep}
                    totalSteps={steps.length}
                    diary={diary}
                    setDiary={setDiary}
                    submit={onContinue}
                    close={close}
                    back={back}
                />
            ))}



        </div>

    );
}

export default DiaryUpsell;
